import {
  formatLeaseTariff,
  formatLeaseTariffBillingFrequency,
} from "./formatting-utils";

export const currencySymbol = (currencyCode: string): string => {
  const symbol = new Intl.NumberFormat("en", {
    style: "currency",
    currency: currencyCode,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  })
    .formatToParts(1)
    .find((part) => part.type === "currency")?.value;
  return symbol!;
};

export const fractionalCurrencySymbol = (currencyCode: string): string => {
  if (currencyCode === "EUR") {
    return "¢";
  }
  return "p";
};

export const GBP_TO_EUR = 1.175;

export const formatTariff = (
  tariff: number,
  ppaPurchaseModel: string,
  ppaLeaseBillingFrequency: string,
  isLandlord: boolean,
  currencyCode: string,
  includeKwhSuffix: boolean,
  includePvLeasePeriod: boolean
) => {
  if (ppaPurchaseModel === "fixed_lease") {
    return `${formatLeaseTariff(
      tariff,
      isLandlord ? "annually" : ppaLeaseBillingFrequency,
      currencyCode
    )}${
      includePvLeasePeriod
        ? ` / ${formatLeaseTariffBillingFrequency(
            isLandlord ? "annually" : ppaLeaseBillingFrequency
          ).toLowerCase()}`
        : ""
    }`;
  }
  return `${(tariff * 100).toFixed(2)}${fractionalCurrencySymbol(currencyCode)}${includeKwhSuffix ? "/kWh" : ""}`;
};
